import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-block.svg'


const _withScopeId = n => (_pushScopeId("data-v-7445c660"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "section"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Datos personales", -1))
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "10px",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "normal-case h-full" }, "Cambiar contraseña", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "section border-b border-t" }
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_15 = {
  key: 1,
  class: "section"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-[16px] text-left" }, "Cuenta seleccionada", -1))
const _hoisted_17 = { class: "col-span-4 lg:col-span-1 flex justify-between items-center border rounded px-3 py-2 cursor-pointer" }
const _hoisted_18 = { class: "flex justify-between items-center w-full" }
const _hoisted_19 = { class: "flex flex-col justify-start items-start gap-1" }
const _hoisted_20 = { class: "text-[14px]" }
const _hoisted_21 = { class: "text-[14px]" }
const _hoisted_22 = {
  key: 0,
  class: "text-[12px]"
}
const _hoisted_23 = {
  key: 1,
  class: "text-[12px]"
}
const _hoisted_24 = {
  key: 2,
  class: "section border-b"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información de la empresa", -1))
const _hoisted_26 = { class: "flex lg:flex-row flex-col gap-4" }
const _hoisted_27 = {
  key: 3,
  class: "section"
}
const _hoisted_28 = { class: "section-title" }
const _hoisted_29 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_30 = {
  key: 4,
  class: "section border-b border-t"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Datos de contacto", -1))
const _hoisted_32 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_33 = {
  key: 5,
  class: "section border-b"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información personería", -1))
const _hoisted_35 = { class: "flex gap-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "flex text-sm font-semibold pb-1",
  for: "datepicker"
}, " Fecha de la escritura ", -1))
const _hoisted_37 = {
  key: 6,
  class: "section border-b"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title" }, "Información bancaria", -1))
const _hoisted_39 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_40 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_41 = { class: "flex items-center mb-5 mr-5" }
const _hoisted_42 = ["disabled"]

import { ref, onMounted, computed, watch } from "vue";
import { storeToRefs } from "pinia";

import useBankStore from "@/stores/banks";

import { bankAccountTypes } from "@/services/auth/types";
import { accountStore } from "@/stores/account";
import { useAuthStore } from "@/stores/auth";

import { reformatDateISO8601 } from "@/services/utils";

import TextField from "@/components/atoms/TextField.vue";
import Selector from "@/components/atoms/Selector.vue";
import ChangePasswordForm from "@/components/molecules/ChangePasswordForm.vue";
import NewAccountModal from "@/components/organisms/NewAccountModal.vue";
import SelectorSimpler from "@/components/atoms/SelectorSimpler.vue";

import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderIdentificationTab',
  setup(__props) {

const authStore = useAuthStore();
const {
  user: shareholder,
  updateUserErrors,
  updateUserIsPending,
} = storeToRefs(authStore);

const accountStr = accountStore();
const { accountSelected, updateAccountErrors, updateAccountIsPending } =
  storeToRefs(accountStr);

const accountEditForm = ref<any>({ ...accountSelected.value });

const banksStore = useBankStore();
const { bankListable } = storeToRefs(banksStore);

const showChangePasswordModal = ref<boolean>(false);
const visible = ref<boolean>(false);

const changed = ref<boolean>(false);

const enableSubmit = computed(() => {
  const noErrors =
    Object.keys(updateAccountErrors?.value || {}).length === 0 &&
    Object.keys(updateUserErrors?.value || {}).length === 0;
  const notPending = !updateUserIsPending?.value && !updateAccountIsPending?.value;
  return (noErrors && notPending) || changed.value;
});

async function setWritingDate(date: string) {
  if (accountEditForm.value == undefined) return;
  accountEditForm.value.writingDate = reformatDateISO8601(new Date(date));
}

async function submitUser() {
  if (shareholder.value == undefined) return;
  if (
    (await authStore.updateUser()) &&
    (await accountStr.updateAccount(accountEditForm.value))
  ) {
    Swal.fire({
      icon: "success",
      title: "¡Éxito!",
      text: "Perfil actualizado exitosamente",
    });
    changed.value = false;
  }
}

const openChangePasswordModal = () => {
  showChangePasswordModal.value = true;
};

// Validadores puros (solo lectura) para evitar bucle infinito en render en producción.
const hasErrorShareholder = (field: string): boolean => {
  const user = shareholder.value as Record<string, unknown> | undefined;
  const val = (user?.[field] ?? "").toString().trim();
  const errs = updateUserErrors?.value?.[field];
  return !val || (Array.isArray(errs) && errs.length > 0);
};

const hasErrorAccount = (field: string): boolean => {
  const val = (accountEditForm.value?.[field] ?? "").toString().trim();
  const errs = updateAccountErrors?.value?.[field];
  return !val || (Array.isArray(errs) && errs.length > 0);
};


watch(
  () => [accountEditForm.value, shareholder.value],
  () => {
    changed.value = true;
  },
  { deep: true }
);


function normalizeFullNameInFirstName() {
  const u = shareholder.value;
  if (!u) return;
  const first = (u.firstName ?? "").toString().trim();
  const last = (u.lastName ?? "").toString().trim();
  if (!first || last) return;
  const parts = first.split(/\s+/);
  if (parts.length < 2) return;
  u.firstName = parts[0];
  u.lastName = parts.slice(1).join(" ");
  authStore.setUser(u);
}

watch(
  () => shareholder.value,
  (val) => {
    if (val?.firstName) normalizeFullNameInFirstName();
  },
  { immediate: true }
);

onMounted(async () => {
  await banksStore.fetchBanks();
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(shareholder))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (
          _unref(shareholder).isBusiness &&
          _unref(shareholder).businessName &&
          _unref(shareholder).businessAddress &&
          _unref(shareholder).businessRut
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: _unref(shareholder).businessName,
                      "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_unref(shareholder).businessName) = $event)),
                      type: "text",
                      name: "company",
                      label: "Razón social",
                      "has-error": hasErrorShareholder('businessName'),
                      "error-message": "'Error'",
                      "hide-details": "",
                      readonly: ""
                    }, null, 8, ["model", "has-error"]),
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: _unref(shareholder).businessAddress,
                      "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_unref(shareholder).businessAddress) = $event)),
                      type: "text",
                      name: "address",
                      label: "Dirección",
                      "has-error": hasErrorShareholder('address'),
                      "error-message": "'Dirección inválida'",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"]),
                    _createVNode(TextField, {
                      model: _unref(shareholder).businessRut,
                      "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_unref(shareholder).businessRut) = $event)),
                      type: "text",
                      name: "",
                      label: "Rut",
                      "has-error": false,
                      "error-message": "El rut no es válido o no se encuentra en el formato indicado (Ej: 12345678-9)",
                      "hide-details": "",
                      readonly: ""
                    }, null, 8, ["model"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_unref(shareholder).isBusiness
              ? "Información representante"
              : "Datos personales"), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TextField, {
                  class: "col-span-4 lg:col-span-1",
                  model: _unref(shareholder).firstName,
                  "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_unref(shareholder).firstName) = $event)),
                  type: "text",
                  name: "firstName",
                  label: "Nombre",
                  "has-error": hasErrorShareholder('firstName'),
                  "error-message": "Nombre no valido",
                  "hide-details": "",
                  readonly: ""
                }, null, 8, ["model", "has-error"]),
                _createVNode(TextField, {
                  class: "col-span-4 lg:col-span-1",
                  model: _unref(shareholder).lastName,
                  "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_unref(shareholder).lastName) = $event)),
                  type: "text",
                  name: "lastName",
                  label: "Apellido",
                  "has-error": hasErrorShareholder('lastName'),
                  "error-message": "Apellido indicado no es valido",
                  "hide-details": "",
                  readonly: ""
                }, null, 8, ["model", "has-error"]),
                _createVNode(TextField, {
                  class: "col-span-4 lg:col-span-1",
                  model: _unref(shareholder).rut,
                  "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_unref(shareholder).rut) = $event)),
                  type: "text",
                  name: "userRut",
                  label: "Rut",
                  "has-error": false,
                  "error-message": "El rut ingresado no es valido o no tiene un formato correcto (Ej: 12345678-9)",
                  "hide-details": "",
                  readonly: ""
                }, null, 8, ["model"]),
                _createVNode(TextField, {
                  class: "col-span-4 lg:col-span-1",
                  model: _unref(shareholder).address,
                  "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_unref(shareholder).address) = $event)),
                  type: "text",
                  name: "address",
                  label: "Dirección particular",
                  "has-error": hasErrorShareholder('address'),
                  "error-message": "La dirección ingresada no es valida",
                  "hide-details": ""
                }, null, 8, ["model", "has-error"])
              ]),
              _createElementVNode("div", { class: "col-span-4" }, [
                _createElementVNode("button", {
                  onClick: openChangePasswordModal,
                  class: "flex items-center justify-center h-full gap-2"
                }, _hoisted_11)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(shareholder).isBusiness
              ? "Información representante"
              : "Datos de contacto"), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(TextField, {
                  class: "col-span-4 lg:col-span-1",
                  model: _unref(shareholder).email,
                  "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((_unref(shareholder).email) = $event)),
                  type: "text",
                  name: "",
                  label: "Correo eléctronico",
                  "has-error": hasErrorShareholder('email'),
                  "error-message": "El email no es correcto",
                  "hide-details": ""
                }, null, 8, ["model", "has-error"]),
                _createVNode(TextField, {
                  class: "col-span-4 lg:col-span-1",
                  model: _unref(shareholder).phone,
                  "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_unref(shareholder).phone) = $event)),
                  type: "text",
                  name: "phone",
                  label: "Teléfono",
                  "has-error": hasErrorShareholder('phone'),
                  "error-message": "El número de telefono ingresado no es valido",
                  "hide-details": ""
                }, null, 8, ["model", "has-error"])
              ])
            ]),
            (_unref(accountSelected))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(accountSelected)?.businessName
                    ? _unref(accountSelected)?.businessName
                    : `${_unref(accountSelected)?.firstName} ${_unref(accountSelected)?.lastName}`), 1),
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(accountSelected)?.email), 1),
                        (
                  _unref(accountSelected)?.investorNumberA &&
                  _unref(accountSelected)?.investorNumberA > 0
                )
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, " ID B: " + _toDisplayString(_unref(accountSelected)?.investorNumberB) + " - ID A: " + _toDisplayString(_unref(accountSelected)?.investorNumberA), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_23, " ID B: " + _toDisplayString(_unref(accountSelected)?.investorNumberB), 1))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (accountEditForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: accountEditForm.value.businessName,
                      "onUpdate:model": _cache[9] || (_cache[9] = ($event: any) => ((accountEditForm.value.businessName) = $event)),
                      type: "text",
                      name: "company",
                      label: "Razón social",
                      "has-error": false,
                      "error-message": "'Error'",
                      "hide-details": ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: accountEditForm.value.businessAddress,
                      "onUpdate:model": _cache[10] || (_cache[10] = ($event: any) => ((accountEditForm.value.businessAddress) = $event)),
                      type: "text",
                      name: "address",
                      label: "Dirección",
                      "has-error": false,
                      "error-message": "'Error'",
                      "hide-details": ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      model: accountEditForm.value.businessRut,
                      "onUpdate:model": _cache[11] || (_cache[11] = ($event: any) => ((accountEditForm.value.businessRut) = $event)),
                      type: "text",
                      name: "",
                      label: "Rut",
                      "has-error": false,
                      "error-message": "El rut no es válido o no se encuentra en el formato indicado (Ej: 12345678-9)",
                      "hide-details": ""
                    }, null, 8, ["model"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (accountEditForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("h5", _hoisted_28, _toDisplayString(accountEditForm.value.businessName
              ? "Datos del representante legal"
              : "Datos del accionista"), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.firstName,
                      "onUpdate:model": _cache[12] || (_cache[12] = ($event: any) => ((accountEditForm.value.firstName) = $event)),
                      type: "text",
                      name: "firstNameAc",
                      label: "Nombre",
                      "has-error": false,
                      "error-message": "Nombre no valido",
                      "hide-details": "",
                      readonly: ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.lastName,
                      "onUpdate:model": _cache[13] || (_cache[13] = ($event: any) => ((accountEditForm.value.lastName) = $event)),
                      type: "text",
                      name: "lastNameAc",
                      label: "Apellido",
                      "has-error": false,
                      "error-message": "Apellido indicado no es valido",
                      "hide-details": "",
                      readonly: ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.rut,
                      "onUpdate:model": _cache[14] || (_cache[14] = ($event: any) => ((accountEditForm.value.rut) = $event)),
                      type: "text",
                      name: "userRutAc",
                      label: "Rut",
                      "has-error": false,
                      "error-message": "El rut ingresado no es valido o no tiene un formato correcto (Ej: 12345678-9)",
                      "hide-details": "",
                      readonly: ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.address,
                      "onUpdate:model": _cache[15] || (_cache[15] = ($event: any) => ((accountEditForm.value.address) = $event)),
                      type: "text",
                      name: "addressAc",
                      label: "Dirección particular",
                      "has-error": hasErrorAccount('address'),
                      "error-message": "La dirección ingresada no es valida",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (accountEditForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.email,
                      "onUpdate:model": _cache[16] || (_cache[16] = ($event: any) => ((accountEditForm.value.email) = $event)),
                      type: "text",
                      name: "emailAc",
                      label: "Correo eléctronico",
                      "has-error": hasErrorAccount('email'),
                      "error-message": "El email no es correcto",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.phone,
                      "onUpdate:model": _cache[17] || (_cache[17] = ($event: any) => ((accountEditForm.value.phone) = $event)),
                      type: "text",
                      name: "phoneAc",
                      label: "Teléfono",
                      "has-error": hasErrorAccount('phone'),
                      "error-message": "El número de telefono ingresado no es valido",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (accountEditForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _createVNode(_component_Datepicker, {
                        "model-value": accountEditForm.value.writingDate,
                        "onUpdate:modelValue": setWritingDate,
                        "input-class-name": "dp-custom-input",
                        clearable: false,
                        "enable-time-picker": false,
                        placeholder: "Fecha de cuando se otorgó la escritura pública",
                        format: 'yyyy-MM-dd',
                        "model-type": "yyyy-MM-dd",
                        cancelText: 'Cancelar',
                        selectText: 'Seleccionar'
                      }, null, 8, ["model-value"])
                    ]),
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: accountEditForm.value.notary,
                      "onUpdate:model": _cache[18] || (_cache[18] = ($event: any) => ((accountEditForm.value.notary) = $event)),
                      type: "text",
                      name: "notary",
                      label: "Notaria",
                      "has-error": false,
                      "error-message": "no es valido",
                      "hide-details": ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: accountEditForm.value.notaryCity,
                      "onUpdate:model": _cache[19] || (_cache[19] = ($event: any) => ((accountEditForm.value.notaryCity) = $event)),
                      type: "text",
                      name: "notaryCity",
                      label: "Ciudad de notaría",
                      "has-error": false,
                      "error-message": "no es valido",
                      "hide-details": ""
                    }, null, 8, ["model"]),
                    _createVNode(TextField, {
                      class: "flex-1",
                      model: accountEditForm.value.repertoireNumber,
                      "onUpdate:model": _cache[20] || (_cache[20] = ($event: any) => ((accountEditForm.value.repertoireNumber) = $event)),
                      type: "text",
                      name: "repertoire_number",
                      label: "Número de repertorio",
                      "has-error": false,
                      "error-message": "El numero de repertorio no es valido",
                      "hide-details": ""
                    }, null, 8, ["model"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (accountEditForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(SelectorSimpler, {
                      class: "col-span-4 lg:col-span-1",
                      label: "Banco",
                      selected: accountEditForm.value.bankCode,
                      items: _unref(bankListable),
                      "onUpdate:model": _cache[21] || (_cache[21] = 
              (item) => {
                if (accountEditForm.value) {
                  accountEditForm.value.bankCode = item.key;
                }
              }
            )
                    }, null, 8, ["selected", "items"]),
                    _createVNode(Selector, {
                      class: "col-span-4 lg:col-span-1",
                      label: "Tipo de cuenta",
                      model: accountEditForm.value.accountType,
                      "onUpdate:model": _cache[22] || (_cache[22] = ($event: any) => ((accountEditForm.value.accountType) = $event)),
                      items: _unref(bankAccountTypes),
                      "has-error": !!_unref(updateAccountErrors)?.accountType
                    }, null, 8, ["model", "items", "has-error"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.accountNumber,
                      "onUpdate:model": _cache[23] || (_cache[23] = ($event: any) => ((accountEditForm.value.accountNumber) = $event)),
                      type: "text",
                      name: "accountNumber",
                      label: "Número de cuenta",
                      "has-error": !!_unref(updateAccountErrors)?.accountNumber,
                      "error-message": "El numero de cuenta no es valido",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.accountOwnerName,
                      "onUpdate:model": _cache[24] || (_cache[24] = ($event: any) => ((accountEditForm.value.accountOwnerName) = $event)),
                      type: "text",
                      name: "bankUserName",
                      label: "Nombre del titular",
                      "has-error": !!_unref(updateAccountErrors)?.accountOwnerName,
                      "error-message": "El nombre no es valido",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1",
                      model: accountEditForm.value.accountOwnerRut,
                      "onUpdate:model": _cache[25] || (_cache[25] = ($event: any) => ((accountEditForm.value.accountOwnerRut) = $event)),
                      type: "text",
                      name: "",
                      label: "Rut del titular",
                      "has-error": !!_unref(updateAccountErrors)?.accountOwnerRut,
                      "error-message": "Rut no valido o en formato incorrecto (Ej:12345678-9)",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"]),
                    _createVNode(TextField, {
                      class: "col-span-4 lg:col-span-1 text-start",
                      model: accountEditForm.value.accountEmail,
                      "onUpdate:model": _cache[26] || (_cache[26] = ($event: any) => ((accountEditForm.value.accountEmail) = $event)),
                      type: "text",
                      name: "",
                      label: "Correo eléctronico de notificación",
                      "has-error": !!_unref(updateAccountErrors)?.accountEmail,
                      "error-message": "El email no es valido",
                      "hide-details": ""
                    }, null, 8, ["model", "has-error"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("button", {
          class: "success btn ml-auto",
          disabled: !_unref(enableSubmit),
          onClick: submitUser
        }, " Guardar ", 8, _hoisted_42)
      ])
    ]),
    _createVNode(NewAccountModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((visible).value = $event))
    }, null, 8, ["visible"]),
    (showChangePasswordModal.value)
      ? (_openBlock(), _createBlock(ChangePasswordForm, {
          key: 0,
          visible: showChangePasswordModal.value,
          "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((showChangePasswordModal).value = $event))
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})